
export class GeneralHomePage {
    linkCenterMap: Map<string, string>;

    constructor() {

        //document.ready
        $(() => {

            $(".popup").on('focus', function () {
                $(this).addClass("show");
            });

            $(".popup").on('blur', function () {
                $(this).removeClass("show")
            })

            this.linkCenterMap = new Map<string, string>();
            this.linkCenterMap.set("Machine Learning-enabled Design of Prototype Pathogen Vaccines and Antibodies", "/centers/ml-enabled");
            this.linkCenterMap.set("Bunyavirus and Picornavirus Pandemic Pathogen Preparedness Center", "/centers/bp4");
            this.linkCenterMap.set("Prepositioning Optimized Strategies for Vaccines and Immunotherapeutics against Diverse Emerging Infectious Threats", "/centers/provident");
            this.linkCenterMap.set("Vaccines and Therapeutic Antibodies to Respiro, Rubula, Peribunya and Phenuiviridae", "/centers/r2p2");
            this.linkCenterMap.set("Flavivirus and Alphavirus ReVAMPP", "/centers/flare");
            this.linkCenterMap.set("Paramyxoviridae and Bunyavirales Vaccines and Antibodies Center", "/centers/pabvax");
            this.linkCenterMap.set("The UCI Vaccines for Pandemic <br>Preparedness Center", "/centers/vppc");
            this.linkCenterMap.set("Coordination and Data Sharing Center", "/about-revampp#cdsc-info");
        });

    }
    togglePopup(popupId, title, content) {

        const popup = document.getElementById(popupId);

        if (popup.classList.contains("show")) {
            // Closing the popup
            popup.classList.remove("show");
            setTimeout(() => {
                popup.style.display = "none";
            }, 300); // Timeout to match the transition duration
        } else {
            // Opening the popup
            const header = document.querySelector(`#${popupId} .popup-header`)
            const popupContent = document.querySelector(`#${popupId} .popup-content`);
            const cta = document.querySelector(`#${popupId} .popup-cta`);
            if (this.linkCenterMap.has(title)) {
                cta.innerHTML = `
                    <div class="text-center mb-3 mt-1">
                        <a class="greenbtn text-decoration-none" href="${this.linkCenterMap.get(title)}">View Center</a>
                    </div>`;
            }
            else {
                cta.innerHTML = "";
            }
            /*render shortcode in text elements*/
            header.textContent = title;
            header.innerHTML = title;
            popupContent.innerHTML = content; // Use innerHTML to render HTML tags
            popup.classList.add("show")
            popup.style.display = "block";
            popup.focus();
        }

    }

    closePopup(propId) {
        // Close the popup when clicking anywhere inside it
        let popup = document.getElementById(propId);
        popup.classList.remove("show");
        setTimeout(() => {
            popup.style.display = "none";
            popup.blur();
        }, 300); // Match the timeout with transition duration
    };

}